<template>
  <p class="control has-icon search-container">
    <input class="input is-medium" type="text" placeholder="Procurar Utilizadores" v-model="searchString">
    <i class="fa fa-search"></i>
  </p>
</template>

<script>
  export default {
    data () {
      return {
        searchString: null
      }
    },

    methods: {
    }
  }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// UserSearch.vue?9192e65e